import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  isDevMode,
  ErrorHandler,
} from '@angular/core';
import {provideRouter, Router, TitleStrategy, withComponentInputBinding, withInMemoryScrolling, withViewTransitions} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http';
import {httpApiInterceptor} from '@shared/interceptors/http-api.interceptor';
import {httpApiErrorInterceptor} from '@shared/interceptors/http-api-error-interceptor';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ENDPOINT_DOMAIN, ENDPOINT_DOMAIN_API, ENDPOINT_DOMAIN_FORM} from '@shared/consts/auth';
import {
  EMAIL_SUPPORT,
  ENDPOINT_BASE_SITE,
  ENDPOINT_PAGE_COOKIES,
  ENDPOINT_PAGE_PRIVACY_POLICY,
  ENDPOINT_PAGE_TERMS,
  GOOGLE_CLIENT_ID,
  GOOGLE_MAP_API_KEY,
} from '@shared/consts/base';
import {fnAppInitializerFactory} from '@shared/utils/fn.app-initializer-factory';
import {provideToast} from '@bs-toast';
import {CF_TURNSTILE_SITE_KEY} from '@cf-turnstile';
import {environment} from '../environments/environment';
import {PageTitleStrategy} from '@shared/services/page-title.strategy';
import {provideServiceWorker} from '@angular/service-worker';
import * as Sentry from '@sentry/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideHttpClient(withXhr(), withInterceptors([httpApiInterceptor, httpApiErrorInterceptor])),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    importProvidersFrom(FormsModule),
    importProvidersFrom(ReactiveFormsModule),
    provideRouter(
      routes,
      withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
      withComponentInputBinding(),
      withViewTransitions({
        skipInitialTransition: true,
      })
    ),
    {provide: ENDPOINT_DOMAIN, useValue: environment.ENDPOINT_DOMAIN},
    {provide: ENDPOINT_DOMAIN_API, useValue: environment.ENDPOINT_DOMAIN_API},
    {provide: ENDPOINT_DOMAIN_FORM, useValue: environment.ENDPOINT_DOMAIN_FORM},
    {provide: ENDPOINT_PAGE_TERMS, useValue: environment.ENDPOINT_PAGE_TERMS},
    {provide: ENDPOINT_BASE_SITE, useValue: environment.ENDPOINT_BASE_SITE},
    {provide: ENDPOINT_PAGE_COOKIES, useValue: environment.ENDPOINT_PAGE_COOKIES},
    {provide: ENDPOINT_PAGE_PRIVACY_POLICY, useValue: environment.ENDPOINT_PAGE_PRIVACY_POLICY},
    {provide: CF_TURNSTILE_SITE_KEY, useValue: environment.CfTurnstileSiteKey},
    {provide: GOOGLE_CLIENT_ID, useValue: environment.googleClientId},
    {provide: EMAIL_SUPPORT, useValue: environment.emailSupport},
    {provide: GOOGLE_MAP_API_KEY, useValue: environment.googleMapApiKey},
    provideAppInitializer(() => fnAppInitializerFactory()),
    {
      provide: TitleStrategy,
      useClass: PageTitleStrategy,
    },
    provideToast({
      // disableTimeOut: 'timeOut', // true
      preventDuplicates: true,
      timeOut: 7000,
      tapToDismiss: false,
      closeButton: true,
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:10000',
    }),
  ],
};
